const searchAjaxRoot = document.querySelector(
  '.js-search-ajax__root',
) as HTMLDivElement
const searchAjaxTrigger = document.querySelector(
  '.js-search-ajax__trigger',
) as HTMLButtonElement
const searchAjaxInput = document.querySelector(
  '.js-search-ajax__input',
) as HTMLInputElement
const searchAjaxDataFetch = document.querySelector(
  '.js-search-ajax__data-fetch',
) as HTMLDivElement
const searchAjaxOverlay = document.querySelector(
  '.js-search-ajax__overlay',
) as HTMLDivElement
const searchAjaxContent = document.querySelector(
  '.js-search-ajax__content',
) as HTMLDivElement
const searchAjaxInputCancelButton = document.querySelector(
  '.js-search-ajax__input-cancel-button',
) as HTMLInputElement

const searchAjaxAdminUrl = ajaxObject.ajaxUrl

type updateSearchAjaxStateProps = 'open' | 'closed'

function fetchResults() {
  if (!searchAjaxInput) {
    console.error('searchAjaxInput was not found in the DOM.')
    return
  }

  const keyword = searchAjaxInput.value.trim()

  if (keyword === '') {
    const searchAjaxText = document.createElement('p')

    searchAjaxText.textContent = 'Faça sua busca...'
    searchAjaxText.classList.add('dialog-search__text')
    searchAjaxDataFetch.innerHTML = ''
    searchAjaxDataFetch.appendChild(searchAjaxText)
    return
  }

  fetch(searchAjaxAdminUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: `action=data_fetch&keyword=${encodeURIComponent(keyword)}`,
  })
    .then((response) => {
      if (response.ok) {
        return response.text()
      }

      throw new Error('AJAX request error')
    })
    .then((data) => {
      searchAjaxDataFetch.innerHTML = data.trim() === '' ? '' : data
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}

const updateSearchAjaxState = (state: updateSearchAjaxStateProps) => {
  if (
    !searchAjaxRoot ||
    !searchAjaxTrigger ||
    !searchAjaxContent ||
    !searchAjaxOverlay
  ) {
    return
  }

  const isClose = state === 'closed'
  const isOpen = state === 'open'

  searchAjaxRoot.setAttribute('data-state', state)
  searchAjaxRoot.setAttribute('aria-hidden', isClose ? 'true' : 'false')
  searchAjaxRoot.setAttribute('tabindex', isClose ? '-1' : '0')

  searchAjaxTrigger.setAttribute('data-state', state)
  searchAjaxTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')

  searchAjaxContent.setAttribute('data-state', state)
  searchAjaxOverlay.setAttribute('data-state', state)
}

const openSearchAjax = () => {
  updateSearchAjaxState('open')
  document.body.style.pointerEvents = 'none'
  document.body.style.overflow = 'hidden'

  if (searchAjaxRoot) {
    searchAjaxRoot.style.opacity = '1'
    searchAjaxRoot.style.pointerEvents = 'auto'
  }

  searchAjaxInput?.focus()

  fetchResults()
}

if (searchAjaxInput && searchAjaxInputCancelButton) {
  searchAjaxInputCancelButton.setAttribute('data-state', 'closed')

  searchAjaxInput.addEventListener('input', () => {
    const inputState = searchAjaxInput.value.trim() === '' ? 'closed' : 'open'

    searchAjaxInputCancelButton.setAttribute('data-state', inputState)
  })

  searchAjaxInputCancelButton.addEventListener('click', () => {
    searchAjaxInput.value = ''
    searchAjaxInput.focus()
    fetchResults()
  })
}

const closeSearchAjax = () => {
  updateSearchAjaxState('closed')
  document.body.style.pointerEvents = ''
  document.body.style.overflow = ''

  searchAjaxRoot.style.opacity = '0'
  searchAjaxRoot.style.pointerEvents = 'none'

  if (searchAjaxInput) {
    searchAjaxInput.value = ''
  }

  searchAjaxInputCancelButton?.setAttribute('data-state', 'closed')

  searchAjaxTrigger?.focus()
}

const handleEscapeKey = (e: KeyboardEvent) => {
  if (e.key === 'Escape' && !e.shiftKey) {
    if (searchAjaxRoot.getAttribute('data-state') === 'open') {
      e.preventDefault()
      closeSearchAjax()
    }
  }
}

searchAjaxOverlay?.addEventListener('click', closeSearchAjax)

searchAjaxTrigger?.addEventListener('click', openSearchAjax)

if (handleEscapeKey) {
  document.addEventListener('keydown', handleEscapeKey)
}
